"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSp = undefined;

var _getSubDomain = require("./getSubDomain");

var isSp = exports.isSp = function () {
  var subDomain = (0, _getSubDomain.getSubDomain)();
  return subDomain !== "www" && subDomain !== "finbursa" && subDomain !== "finbursadev" && subDomain !== "finbursauat" && subDomain !== "localhost:8082";
};